import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Lemonade Shoes' "ZENNY - Statement Mule Sandal"
// (p_xjrrg85rkj), read from GET /api/product-reviews/product/p_xjrrg85rkj —
// verbatim comment, real reviewer, real rating, real publish date.
export const review_ls4: FaireReviewEntity = {
  token: "review_ls4",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  productToken: "p_xjrrg85rkj",
  reviewType: "product",
  reviewerName: "Bianca R.",
  reviewerLocation: "Philadelphia, PA",
  stars: 5,
  reviewText: "I will be coming back to get the other 2 colors!",
  reviewDate: "Dec 30, 2025",
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:55:00.000Z",
    importedBy: "entity-db-cli",
  },
};
